import { createAction, props } from "@ngrx/store";

export const allEmployeeFields = createAction(
  'allEmployeeFields',
  props<{ allEmployeeFields: any }>()
);

